import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "@/components/layouts/ConfirmationModal";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit: () => void;
  handleCancel?: () => void;
}

const UnsavedChangesInDrawerModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  handleSubmit,
  handleCancel
}) => {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("unsavedChangesInDrawer.title")}
      confirmationText={t("unsavedChangesInDrawer.message")}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      submitButtonText={t("unsavedChangesInDrawer.saveChanges")}
      cancelButtonText={t("unsavedChangesInDrawer.discard")}
      isPrimaryButton
      hideDivider
    />
  );
};

export default UnsavedChangesInDrawerModal;
